import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function WarningModal({ show, onClose, message, title = "Warning" }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#d9534f" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="warning" onClick={onClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default WarningModal;